import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import {
  MARKETING_CONSENT_EXTERNAL_URL,
  PRIVACY_POLICY_EXTERNAL_URL,
  PUBLIC_OFFER_PATH,
} from '../../legal/publicOffer'

type AuthScreenLayoutProps = {
  children?: ReactNode
  wide?: boolean
  scrollable?: boolean
  loading?: boolean
  variant?: 'default' | 'register'
}

export const AuthScreenLayout = ({
  children,
  wide = false,
  scrollable = false,
  loading = false,
  variant = 'default',
}: AuthScreenLayoutProps) => {
  if (loading) {
    return (
      <main className="market-auth">
        <div className="market-auth__main market-auth__main--loading">
          <p className="market-auth__loading">Загрузка…</p>
        </div>
      </main>
    )
  }

  const isRegister = variant === 'register'
  const mainClass = [
    'market-auth__main',
    isRegister ? 'market-auth__main--register' : '',
    !isRegister && scrollable ? 'market-auth__main--scroll' : '',
  ]
    .filter(Boolean)
    .join(' ')
  const stackClass = [
    'market-auth__stack',
    isRegister ? 'market-auth__stack--register' : '',
    !isRegister && wide ? 'market-auth__stack--wide' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <main className={`market-auth${isRegister ? ' market-auth--register' : ''}`}>
      <aside className="market-auth__brand" aria-hidden="true" />

      <div className={mainClass}>
        <div className={stackClass}>
          {children}
          <nav className="market-auth__legal-links" aria-label="Юридические документы">
            <a href={PRIVACY_POLICY_EXTERNAL_URL} target="_blank" rel="noopener noreferrer">
              Политика конфиденциальности
            </a>
            <Link to={PUBLIC_OFFER_PATH}>Оферта</Link>
            <a href={MARKETING_CONSENT_EXTERNAL_URL} target="_blank" rel="noopener noreferrer">
              Согласие на рекламу
            </a>
          </nav>
        </div>
      </div>
    </main>
  )
}
